import clsx from "clsx";
import { ReactComponent as LoadingIconStatic } from "./loader.svg";
import styles from "./LoadingIcon.module.scss";

export function LoadingIcon(props) {
  return <LoadingIconStatic className={clsx(styles.loadingIcon)} {...props} />;
}
